module.exports = __webpack_public_path__ + "static/media/dashboard-preview.fbd8ecae.svg";